import React, { useState, useRef, useEffect } from 'react'
import { Box, TextField, Typography, IconButton, Paper, Tabs, Tab, InputAdornment } from '@mui/material'
import { 
  SentimentSatisfiedAlt as SmileIcon,
  Search as SearchIcon,
  Close as CloseIcon,
  Schedule as ClockIcon,
  Favorite as HeartIcon,
  WbSunny as SparkleIcon,
} from '@mui/icons-material'

// Popular emojis organized by category
const emojiCategories = {
  recent: [],
  smileys: ['😀', '😃', '😄', '😁', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓'],
  gestures: ['👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️', '👍', '👎', '✊', '👊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '💪'],
  hearts: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❤️‍🔥', '❤️‍🩹', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '❣️', '💌', '💋', '💯'],
  nature: ['🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🐔', '🐧', '🐦', '🐤', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗', '🐴', '🦄', '🐝', '🪱', '🐛', '🦋', '🐌', '🐞', '🐜', '🌸', '💐', '🌹', '🥀', '🌺', '🌻', '🌼', '🌷', '🌱', '🪴', '🌲', '🌳', '🌴', '🌵', '🌾', '🌿', '☘️', '🍀'],
  food: ['🍎', '🍏', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🫐', '🍈', '🍒', '🍑', '🥭', '🍍', '🥥', '🥝', '🍅', '🍆', '🥑', '🥦', '🥬', '🥒', '🌶️', '🫑', '🌽', '🥕', '🧄', '🧅', '🥔', '🍠', '🥐', '🥯', '🍞', '🥖', '🥨', '🧀', '🥚', '🍳', '🥞', '🧇', '🥓', '🥩', '🍗', '🍖', '🌭', '🍔', '🍟', '🍕', '🥪', '🥙', '🌮', '🌯', '🥗', '🥘', '🍝', '🍜', '🍲', '🍛', '🍣', '🍱', '🥟', '🍤', '🍙', '🍚', '🍘', '🍥', '🍧', '🍨', '🍦', '🥧', '🧁', '🍰', '🎂', '🍮', '🍭', '🍬', '🍫', '🍿', '🍩', '🍪'],
  activities: ['⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱', '🏓', '🏸', '🏒', '🏑', '🥍', '🏏', '🥅', '⛳', '🏹', '🎣', '🤿', '🥊', '🥋', '🎽', '🛹', '🛼', '⛸️', '🥌', '🎿', '⛷️', '🏂', '🏋️', '🤼', '🤸', '🤺', '🤾', '🏌️', '🏇', '🧘', '🏄', '🏊', '🤽', '🚣', '🧗', '🚴', '🚵', '🎪', '🎭', '🎨', '🎬', '🎤', '🎧', '🎼', '🎹', '🥁', '🎷', '🎺', '🎸', '🎻', '🎲', '🎯', '🎳', '🎮', '🎰'],
  travel: ['🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚐', '🚚', '🚛', '🚜', '🚲', '🛵', '🏍️', '🛺', '🚨', '🚔', '🚍', '🚘', '🚖', '🚡', '🚠', '🚟', '🚃', '🚋', '🚝', '🚄', '🚅', '🚈', '🚂', '🚆', '🚇', '🚊', '🚉', '✈️', '🛫', '🛬', '🛩️', '💺', '🚀', '🛸', '🚁', '🛶', '⛵', '🚤', '🛥️', '🛳️', '⛴️', '🚢', '⚓', '🗺️', '🗿', '🗽', '🗼', '🏰', '🏯', '🏟️', '🎡', '🎢', '🎠', '⛲', '⛱️', '🏖️', '🏝️', '🏜️', '🌋', '⛰️', '🏔️', '🗻'],
  objects: ['⌚', '📱', '📲', '💻', '⌨️', '🖥️', '🖨️', '🖱️', '🖲️', '🕹️', '💾', '💿', '📀', '📼', '📷', '📸', '📹', '🎥', '📞', '☎️', '📟', '📠', '📺', '📻', '🎙️', '🎚️', '🎛️', '⏱️', '⏲️', '⏰', '🕰️', '⌛', '⏳', '📡', '🔋', '🔌', '💡', '🔦', '🕯️', '🪔', '💸', '💵', '💴', '💶', '💷', '🪙', '💰', '💳', '💎', '⚖️', '🔧', '🔨', '⚒️', '🛠️', '⛏️', '🔩', '⚙️', '🔫', '💣', '🔪', '🗡️', '⚔️', '🛡️', '🔮', '💈', '⚗️', '🔭', '🔬', '💊', '💉', '🩹', '🩺', '🌡️', '🧹', '🧺', '🧻', '🚽', '🚰', '🚿', '🛁', '🧼', '🧽', '🧴', '🔑', '🗝️', '🚪', '🛋️', '🛏️', '🖼️', '🛍️', '🎁', '🎈', '🎀', '🎊', '🎉'],
  symbols: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '✨', '💫', '⭐', '🌟', '✴️', '💯', '🔥', '💥', '❗', '❓', '❕', '❔', '⚠️', '🚸', '✅', '❎', '❌', '⭕', '🛑', '⛔', '📛', '🚫', '♻️', '💠', '🔰', '✳️', '❇️', '💹', '📶', '🔱', '⚜️', '🔴', '🟠', '🟡', '🟢', '🔵', '🟣', '⚫', '⚪', '🟤', '▶️', '⏸️', '⏹️', '⏺️', '⏭️', '⏮️', '⏩', '⏪', '🔀', '🔁', '🔂', '➡️', '⬅️', '⬆️', '⬇️', '↗️', '↘️', '↙️', '↖️', '🔄', '🎵', '🎶', '➕', '➖', '✖️', '➗', '💲', '💱', '™️', '©️', '®️', '〰️', '➰', '✔️', '☑️', '🔘'],
}

interface MUIEmojiPickerProps {
  onEmojiSelect: (emoji: string) => void
  onClose: () => void
}

const MUIEmojiPicker: React.FC<MUIEmojiPickerProps> = ({ onEmojiSelect, onClose }) => {
  const [activeCategory, setActiveCategory] = useState<keyof typeof emojiCategories>('smileys')
  const [searchQuery, setSearchQuery] = useState('')

  const categoryLabels = {
    recent: 'Recent',
    smileys: 'Smileys',
    gestures: 'Gestures',
    hearts: 'Hearts',
    nature: 'Nature',
    food: 'Food',
    activities: 'Activities',
    travel: 'Travel',
    objects: 'Objects',
    symbols: 'Symbols',
  }

  const getFilteredEmojis = () => {
    if (!searchQuery) {
      return emojiCategories[activeCategory]
    }
    const allEmojis = Object.values(emojiCategories).flat()
    return allEmojis.filter(emoji => emoji.includes(searchQuery))
  }

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'absolute',
        bottom: 'calc(100% + 8px)',
        left: 0,
        width: '352px',
        zIndex: 1300,
        background: 'linear-gradient(135deg, rgba(17, 24, 39, 0.98) 0%, rgba(31, 41, 55, 0.98) 100%)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(168, 85, 247, 0.2)',
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      {/* Header with search and close */}
      <Box sx={{ p: 2, borderBottom: '1px solid rgba(168, 85, 247, 0.2)' }}>
        <Box sx={{ display: 'flex', gap: 1, mb: 1.5 }}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search emojis..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: 18 }} />
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: 'rgba(168, 85, 247, 0.2)' },
                '&:hover fieldset': { borderColor: 'rgba(168, 85, 247, 0.4)' },
                '&.Mui-focused fieldset': { borderColor: '#a855f7' },
                backgroundColor: 'rgba(15, 23, 42, 0.5)',
              },
              '& .MuiInputBase-input': {
                color: '#fff',
                fontSize: '14px',
              },
            }}
          />
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              color: 'rgba(255, 255, 255, 0.6)',
              '&:hover': { backgroundColor: 'rgba(168, 85, 247, 0.1)' },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Category tabs */}
        {!searchQuery && (
          <Tabs
            value={activeCategory}
            onChange={(_, newValue) => setActiveCategory(newValue)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: 36,
              '& .MuiTabs-indicator': {
                backgroundColor: '#a855f7',
              },
              '& .MuiTab-root': {
                minHeight: 36,
                minWidth: 40,
                padding: '6px 12px',
                color: 'rgba(255, 255, 255, 0.6)',
                fontSize: 11,
                '&.Mui-selected': {
                  color: '#fff',
                  background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
                  borderRadius: 1,
                },
              },
            }}
          >
            {(Object.keys(emojiCategories) as Array<keyof typeof emojiCategories>).map((category) => (
              <Tab
                key={category}
                value={category}
                label={categoryLabels[category]}
              />
            ))}
          </Tabs>
        )}
      </Box>

      {/* Emoji grid */}
      <Box
        sx={{
          height: '280px',
          overflowY: 'auto',
          p: 1.5,
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'rgba(15, 23, 42, 0.5)',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(168, 85, 247, 0.3)',
            borderRadius: '4px',
            '&:hover': {
              background: 'rgba(168, 85, 247, 0.5)',
            },
          },
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(8, 1fr)',
            gap: 0.5,
          }}
        >
          {getFilteredEmojis().map((emoji, index) => (
            <Box
              key={`${emoji}-${index}`}
              component="button"
              onClick={() => onEmojiSelect(emoji)}
              sx={{
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 24,
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                borderRadius: 1,
                transition: 'all 0.2s',
                '&:hover': {
                  backgroundColor: 'rgba(168, 85, 247, 0.2)',
                  transform: 'scale(1.1)',
                },
              }}
              title={emoji}
            >
              {emoji}
            </Box>
          ))}
        </Box>
        {getFilteredEmojis().length === 0 && (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <SmileIcon sx={{ fontSize: 32, color: 'rgba(255, 255, 255, 0.2)', mb: 1 }} />
            <Typography sx={{ fontSize: 14, color: 'rgba(255, 255, 255, 0.5)' }}>
              No emojis found
            </Typography>
          </Box>
        )}
      </Box>

      {/* Footer */}
      <Box
        sx={{
          px: 2,
          py: 1.5,
          backgroundColor: 'rgba(15, 23, 42, 0.5)',
          borderTop: '1px solid rgba(168, 85, 247, 0.2)',
        }}
      >
        <Typography sx={{ fontSize: 12, color: 'rgba(255, 255, 255, 0.5)', textAlign: 'center' }}>
          Click an emoji to add it to your caption
        </Typography>
      </Box>
    </Paper>
  )
}

export default MUIEmojiPicker